import { render, staticRenderFns } from "./PriceSelector.vue?vue&type=template&id=e72bddfa&scoped=true"
import script from "./PriceSelector.vue?vue&type=script&lang=js"
export * from "./PriceSelector.vue?vue&type=script&lang=js"
import style0 from "./PriceSelector.vue?vue&type=style&index=0&id=e72bddfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72bddfa",
  null
  
)

export default component.exports